const SVG_NS = 'http://www.w3.org/2000/svg'

function toSlug(label) {
  return String(label)
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '')
}

function sanitizeLayerLabel(label) {
  if (!label) return label
  return String(label)
    .replace(/^undefined\s*-\s*/i, '')
    .replace(/^undefined_*-_*/i, '')
    .trim()
}

function setLayerName(node, label, fallbackIndex = null) {
  const safeLabel = sanitizeLayerLabel(label)
  if (!node || !safeLabel) return
  const suffix = fallbackIndex === null ? '' : `-${fallbackIndex}`
  const baseId = `layer-${toSlug(safeLabel) || 'group'}${suffix}`

  if (!node.getAttribute('id')) {
    node.setAttribute('id', baseId)
  }
  node.setAttribute('data-name', safeLabel)
  node.setAttribute('inkscape:label', safeLabel)
}

function groupLabelFromNode(node) {
  const id = (node.getAttribute('id') || '').toLowerCase()
  const className = (node.getAttribute('class') || '').toLowerCase()
  const textCount = node.querySelectorAll('text').length
  const rectCount = node.querySelectorAll('rect').length
  const circleCount = node.querySelectorAll('circle').length
  const lineCount = node.querySelectorAll('line').length
  const pathCount = node.querySelectorAll('path').length

  if (node.hasAttribute('data-name')) {
    return null
  }
  if (id.includes('xaxis') || id === 'x-axis' || id === 'x axis') return 'X Axis'
  if (id.includes('yaxis') || id === 'y-axis' || id === 'y axis') return 'Y Axis'
  if (className.includes('legendcolor')) return 'Color Legend'
  if (className.includes('legendsize')) return 'Size Legend'
  if (className.includes('legend')) return 'Legend'
  if (className.includes('grid') || id.includes('grid')) return 'Grid Lines'
  if (textCount > 0 && rectCount === 0 && circleCount === 0 && pathCount === 0 && lineCount === 0) {
    return 'Labels'
  }
  if (circleCount > 0 && rectCount === 0 && pathCount === 0) return 'Point Marks'
  if (rectCount > 0 && circleCount === 0 && pathCount === 0 && textCount === 0) return 'Bar Marks'
  if (pathCount > 0 && rectCount === 0 && circleCount === 0 && textCount === 0) return 'Line Marks'
  if (textCount > 0 && (rectCount > 0 || circleCount > 0 || pathCount > 0)) return 'Annotated Marks'
  if (rectCount > 0 || circleCount > 0 || pathCount > 0 || lineCount > 0) return 'Chart Marks'
  return null
}

function wrapLooseChartNodes(contentGroup) {
  const looseNodes = Array.from(contentGroup.childNodes).filter((node) => {
    if (node.nodeType !== 1) return false
    return !node.hasAttribute('data-name')
  })

  if (looseNodes.length < 2) return

  const wrapper = document.createElementNS(SVG_NS, 'g')
  setLayerName(wrapper, 'Chart Content')
  contentGroup.insertBefore(wrapper, looseNodes[0])
  looseNodes.forEach((node) => wrapper.appendChild(node))
}

export function applySvgLayerNames(svgNode) {
  if (!svgNode) return

  if (!svgNode.getAttribute('xmlns:inkscape')) {
    svgNode.setAttribute('xmlns:inkscape', 'http://www.inkscape.org/namespaces/inkscape')
  }

  const backgroundNode = svgNode.querySelector('[data-lugsail-theme-background="true"]')
  const headerNode = svgNode.querySelector('[data-lugsail-theme-header="true"]')
  const contentGroup = svgNode.querySelector('[data-lugsail-theme-content="true"]')

  setLayerName(backgroundNode, 'Background')
  setLayerName(headerNode, 'Header Group')
  setLayerName(contentGroup, 'Chart Content')

  const groups = Array.from(svgNode.querySelectorAll('g'))
  let unnamedCount = 0
  groups.forEach((group) => {
    const label = groupLabelFromNode(group)
    if (!label) return
    unnamedCount += 1
    setLayerName(group, label, unnamedCount)
  })

  if (contentGroup) {
    wrapLooseChartNodes(contentGroup)
  }

  Array.from(svgNode.querySelectorAll('[data-name], [inkscape\\:label]')).forEach((node) => {
    const explicitDomain = node.getAttribute('data-rawgraphs-color-domain')
    const rawLabel =
      explicitDomain ||
      node.getAttribute('data-name') ||
      node.getAttribute('inkscape:label')
    const safeLabel = sanitizeLayerLabel(rawLabel)
    if (!safeLabel) return
    node.setAttribute('data-name', safeLabel)
    node.setAttribute('inkscape:label', safeLabel)
    if (/^undefined/i.test(node.getAttribute('id') || '')) {
      node.setAttribute('id', `layer-${toSlug(safeLabel) || 'group'}`)
    }
  })
}
